import React, {Suspense, useEffect, useMemo, useState, useRef} from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import {connect} from 'react-redux';
import {createPortal} from 'react-dom';
import URLSearchParams from 'url-search-params';

import ModulePreview from '../../components/ModulePreview';
import {searchBox} from '../../drupalSettings';
import ModuleDestinationSearch from './components/ModuleDestinationSearch';
import {FILTER_DATES, FILTER_DESTINATION} from '../../constants';
import filterChange from '../../actions/filterChange';
import {SEARCH_PARAM_HOTEL_DIRECT_ID} from '../../../../components/searchHomepageWithFilters/constants';
import setHoldKeyword from '../../actions/setHoldKeyword';
import {pushSearchInteract} from 'js/helpers/gtm';

import styles from './SearchModuleDestination.module.scss';

const SEARCH_STICKY_WRAP = 'search-sticky';
const HOTEL_SOURCE = 'hod_hotels'
const GEO_SOURCE = 'geomaj'
const cx = classnames.bind(styles);
const wordings = searchBox?.titles || {};
const {searchResultsUrl} = searchBox || {}

const stickyWrapNode = document.getElementById(SEARCH_STICKY_WRAP)
const SearchModuleDestination = function ({
  className,
  activeFilter,
  filterChangeAction,
  isDatesExist,
  queryString,
  setHoldKeywordAction,
  holdKeyword,
}) {
  const wrapRef = useRef(null);
  const [isDisplaySticky, setIsDisplaySticky] = useState(false)
  const previewValues = useMemo(function () {
    return [{
      label: wordings.wantToLiveIn,
      value: holdKeyword,
      readOnly: true,
    }]
  }, [holdKeyword])
  const isActive = useMemo(() => activeFilter === FILTER_DESTINATION, [activeFilter])

  const onPreviewClick = function () {
    filterChangeAction('activeFilter', FILTER_DESTINATION)
    pushSearchInteract({
      action: 'open',
      field: 'destination'
    })
  }

  const onFormClose = function () {
    filterChangeAction('activeFilter', null)
  }

  const clearSearchParams = (url, params) => {
    params.forEach((param) => {
      url.searchParams.delete(param)
    })

    return url
  }

  const updateUrlParams = function (data) {
    const otherParams = new URLSearchParams(queryString);
    const searchQueryParamsKey = [
      'geoType', 'geoCode', 'offerBanner', 'TK', SEARCH_PARAM_HOTEL_DIRECT_ID, 'offerCity', 'isAutocomplete', 'q',
    ]
    let url = new URL(searchResultsUrl === `${window.location.origin}${window.location.pathname}` ? window.location.href : searchResultsUrl)

    url = clearSearchParams(url, searchQueryParamsKey)
    searchQueryParamsKey.forEach(function (key) {
      otherParams.delete(key)
    })

    url.searchParams.set('q', data.name)
    url.searchParams.set('isAutocomplete', true)

    if (data.source === HOTEL_SOURCE) {
      url.searchParams.append(SEARCH_PARAM_HOTEL_DIRECT_ID, data.id)
    }

    if (data.source === GEO_SOURCE) {
      url.searchParams.append('geoCode', data.id)
      url.searchParams.append('geoType', data.type)
    }

    const pushUrl = `${url.search}&${otherParams.toString()}`
    window.history.replaceState({}, '', pushUrl)
  }

  const onDestinationUpdate = function (data) {
    setHoldKeywordAction(data.name)
    updateUrlParams(data)
  }

  const onDestinationSubmit = function (data) {
    onDestinationUpdate(data)
    filterChangeAction('activeFilter', isDatesExist ? null : FILTER_DATES)
  }

  const manipulateStickyPreview = function () {
    const offset = -120;
    if (!wrapRef?.current) {
      setIsDisplaySticky(false)
      return
    }

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const targetTop = wrapRef.current.offsetTop - offset;

    setIsDisplaySticky(scrollTop >= targetTop)
  }

  useEffect(() => {
    const url = new URL(window.location)
    setHoldKeywordAction(url.searchParams.get('q') || '')
    window.addEventListener('scroll', manipulateStickyPreview)
    manipulateStickyPreview()

    return function () {
      window.removeEventListener('scroll', manipulateStickyPreview)
    }
  }, []);

  return (
    <div className={cx('root', className)} ref={wrapRef}>
      <ModulePreview
        icon="GEOLOC"
        values={previewValues}
        onClick={onPreviewClick}
      />
      {isDisplaySticky && createPortal(
        <div className={cx('sticky-destination')}>
          <ModulePreview
            icon="GEOLOC"
            values={previewValues}
            onClick={onPreviewClick}
          />
        </div>,
        stickyWrapNode
      )}
      {isActive && (
        <Suspense>
          <ModuleDestinationSearch
            onClose={onFormClose}
            value={holdKeyword}
            onUpdate={onDestinationUpdate}
            onSubmit={onDestinationSubmit}
          />
        </Suspense>
      )}
    </div>
  )
}

SearchModuleDestination.propTypes = {
  data: PropTypes.any
}

export default connect(({main, form}) => ({
  data: form?.searchFilters?.rooms || [],
  activeFilter: form?.searchFilters?.activeFilter,
  isDatesExist: !!form?.searchFilters?.dates?.length,
  queryString: main.queryString,
  holdKeyword: main.holdKeyword,
}), {
  filterChangeAction: filterChange,
  setHoldKeywordAction: setHoldKeyword,
})(SearchModuleDestination);
